import * as React from "react";

function SvgSortArrow(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M11.393 5.165L8 0 4.6 5.174a.381.381 0 00.09.514.34.34 0 00.2.066 1.3 1.3 0 001.068-.569l1.5-2.146L7.461 16h1.078V3.046l1.476 2.132a1.32 1.32 0 001.082.578.367.367 0 00.357-.376.39.39 0 00-.061-.215z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgSortArrow);
export default ForwardRef;